<template>
  <div id="pdfPage">

      <div>
        <button @click="openPdf">Ouvrir PDF</button>
      </div>
      <br>
      <div>
        <button @click="printPdf">Imprimer pdf</button>
      </div>
  </div>
</template>

<script>

export default {
  name: 'PdfPage',
  components: {
  },

  data: () => ({
    publicPath: process.env.BASE_URL
  }),

  props: {
  },

  methods: {
    printPdf() {
      var iframe = this.iframeZone;
      if (!this.iframeZone) {
        iframe = this.iframeZone = document.createElement('iframe');
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.onload = function() {
          setTimeout(function() {
            iframe.focus();
            iframe.contentWindow.print();
          }, 1);
        };
      }

      iframe.src = `${this.publicPath}BL.pdf`;
    },
    openPdf() {
      let request = new XMLHttpRequest();
      request.open('GET', `${this.publicPath}BL.pdf`, true);
      request.responseType = 'blob';
      request.onload = () => {
          window.open(URL.createObjectURL(new Blob([request.response], {type: 'application/pdf'})))
      };
      request.send();
    }
  }
}
</script>

<style>
</style>